import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { fetchCompanies } from "../../../store/middleware";
import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";
import Placeholder from "../../../components/Placeholder/PlaceholderByPage";

import { TableUser } from "./styles";

function CompaniesList({ setShowCompanyForm, setSelectedCompany }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { companies } = useSelector((state) => state.b2bCompaniesReducer);

  const emptyFilter = {
    pageNumber: 1,
    pageSize: 999,
    socialName: "",
    fantasyName: "",
    documentNumber: "",
    economicGroupId: "",
    registerDateFrom: "",
    registerDateTo: "",
    active: "",
    responsibleName: "",
    responsibleEmail: "",
  };

  const handleSelectCompany = (item) => {
    setSelectedCompany(item);
    setShowCompanyForm(true);
  };

  useEffect(() => {
    dispatch(fetchCompanies(emptyFilter));
    // eslint-disable-next-line
  }, []);

  return companies && companies?.length > 0 ? (
    <TableUser>
      <div className="bigBox">
        <table>
          <thead>
            <tr>
              <th>{t("LEGAL_NAME")}</th>
              <th>{t("ECONOMIC_GROUP")}</th>
              <th>{t("DOCUMENT_NUMBER")}</th>
              <th>{t("DATE")}</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {companies.map((item) => {
              return (
                <tr key={item.id}>
                  <td>{item.socialName}</td>
                  <td>{item.economicGroup ? decryptIfEncrypted(item.economicGroup.name) : ""}</td>
                  <td>{item.documentNumber}</td>
                  <td>{item.registerDate}</td>
                  <td>
                    <span className={!item.active ? "inativo" : ""}>{item.active ? "Active" : "Inactive"}</span>
                  </td>
                  <td>
                    <button type="button" onClick={() => handleSelectCompany(item)}>
                      {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </TableUser>
  ) : (
    <div style={{ paddingTop: "50px" }}>
      <Placeholder pageName="users" textMsg="Nothing here yet" />
    </div>
  );
}

export default CompaniesList;
